import { getHourOfTheDay } from '@utils';
import {
  FluentStoreAvailabilityResponse,
  InStoreAvailabilityItem,
  FluentOpeningSchedule
} from '.';

const mapHours = (openingSchedule: FluentOpeningSchedule): string[] => openingSchedule.allHours
  ? [ 'Open 24/7' ]
  : [ `${getHourOfTheDay(openingSchedule.monStart)} - ${getHourOfTheDay(openingSchedule.monEnd)}` ];

export const mapStoreAvailabilityData = (data: FluentStoreAvailabilityResponse, sku: string): InStoreAvailabilityItem[] => (
  data.locations.map(({
    name,
    ref,
    primaryAddress,
    openingSchedule
  }) => ({
    name,
    ref,
    address: {
      ...primaryAddress,
      state: primaryAddress.state.split('-').pop()
    },
    isAvailable: data.availability?.[sku]?.some(store => store.ref === ref) ?? false,
    openHours: mapHours(openingSchedule)
  }))
);
